module.exports = __webpack_public_path__ + "img/envelope_error.bb66bb2d.svg";